export default __webpack_public_path__ + "media/images/about-us-01-451x304-a028dfab368b30938d21bff3791ac978.jpg";